import { getAppConfig } from '../..';
export function getScopesB2B() {
    // can't use useConfig hook here because we aren't in a component
    const configuration = getAppConfig();
    return ['openid', 'offline_access', configuration.REACT_APP_BFF_API_SCOPES];
}
